<template>
  <div v-if="rentalUnit" @click="goToPreview(rentalUnit._id as string)">
    <img
      class="rental-unit-image"
      :src="
        rentalUnit?.Images[0] && rentalUnit?.Images[0].image !== ''
          ? rentalUnit?.Images[0].image
          : 'https://st-web.lodgerin.com/images/image-not-found.webp'
      "
      alt=""
    />
    <h4 class="h4 font-lg blue-darker ion-text-nowrap w-100">
      {{ getCurrentName(rentalUnit, language) }}
    </h4>
    <ion-row
      v-if="rentalUnit.Prices && rentalUnit.Prices[0] && !hidePrice"
      class="ion-justify-content-start ion-align-items-center"
    >
      <ion-col size="12" class="ion-no-padding ion-justify-content-start ion-align-items-center">
        <h5 class="h5 font-md bold-medium primary">
          {{
            amountMask(
              rentalUnit.Prices[0].amount as number,
              rentalUnit.Prices[0].currency as string,
            )
          }}
        </h5>
        <p v-if="rentalUnit.Prices[0].paymentCycle" class="font-sm grey padding-x">
          {{
            t(
              `announcement.${rentalUnit.Prices[0].paymentCycle !== 'Unknown' ? rentalUnit.Prices[0].paymentCycle : 'monthly'}`,
            )
          }}
        </p>
      </ion-col>
    </ion-row>
    <ion-row
      v-if="rentalUnit.maxCapacity"
      class="ion-justify-content-center ion-align-items-center"
    >
      <ion-col size="12">
        <ion-icon :icon="peopleOutline"></ion-icon>
        <ion-label>{{ rentalUnit.maxCapacity }}</ion-label>
      </ion-col>
    </ion-row>
  </div>
</template>
<script setup lang="ts">
  import { RentalUnit } from '@/interfaces/elastic/elastic.interface';
  import { useSearch } from '@/composables/useSearch';
  import router from '@/router';
  import { IonRow, IonCol, IonIcon, IonLabel } from '@ionic/vue';
  import { amountMask } from '@/utils/validations/formats';
  import { peopleOutline } from 'ionicons/icons';
  import { useI18n } from 'vue-i18n';

  const { getCurrentName } = useSearch();

  interface Props {
    rentalUnit?: RentalUnit;
    hidePrice?: boolean;
    language: string;
  }

  defineProps<Props>();
  const { t } = useI18n();

  const goToPreview = (idRentalUnit: string) => {
    router.push({ name: 'AnnouncementPage', params: { rentalId: idRentalUnit } });
  };
</script>
<style scoped lang="scss">
  .rental-unit-image {
    height: 100px !important;
    object-fit: cover;
    width: 100%;
    cursor: pointer;
    border-radius: 5px;
  }
</style>
